import type { ShopifyProduct } from "@/models/user";
import { API_BASE, callApi } from "@/services/api";

export async function getShopifyEquipment(): Promise<
  ShopifyProduct[] | undefined
> {
  try {
    const resp = await callApi<ShopifyProduct[]>(
      `${API_BASE}/shopify/collection/dashboard`,
    );
    return resp?.data;
  } catch (e) {
    throw e;
  }
}

interface ShopifySSO {
  shopLoginUrl: string;
}

export async function shopifyLogin(): Promise<ShopifySSO | undefined> {
  try {
    const resp = await callApi<ShopifySSO>(
      `${API_BASE}/shop_login?no_redirect=true`,
    );
    return resp?.data;
  } catch (e) {
    throw e;
  }
}
